import { isEmpty } from 'lodash';
import { translate } from '@td/shared_utils';

export const convertStateCdToStateNm = (state) => (translate(null, "states.state_codes", state))

export const isNumber = str => str && str.trim() !== '' && !isNaN(str);

export const formatProviderName = ({npi, firstNm, lastNm}) => {
  if (isEmpty(npi)) {
    return `${firstNm} ${lastNm}`;
  }

  return `${firstNm} ${lastNm} (NPI: ${npi})`;
};
export const mapToProviderToDropdownOption = ({ id, ...provider }) => {
  return { value: id, label: formatProviderName(provider)};
};
